import './SortTable.scss';
import Component from './SortTable.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);
